import { useNavigate, useSearchParams } from "react-router-dom";
import HomeNavbar from "../../Components/HomeNavbar/HomeNavbar";
import { useEffect, useState } from "react";
import { useSnackbar } from "../../context/SnackbarContext";
import { verifyLinkApi } from "../../api/auth";
import { Backdrop, CircularProgress } from "@mui/material";
import { getProfile } from "../../api/profile";
import { images } from "../../assets/images";

const Verified = () => {
  const [searchParams] = useSearchParams();

  // To get a specific query parameter by key
  const token = searchParams.get("token");

  const { showSnackbar } = useSnackbar();

  const [isLoading, setIsLoading] = useState(false);

  const [success, setSuccess] = useState(false);


  const verifyLink = async () => {
    setIsLoading(true);

    if (token)
      try {
        const response = await verifyLinkApi(token);

        if (response.data.data.id) {
          localStorage.setItem("userId", response.data.data.id);
          showSnackbar(response.data.responseInfo?.description, "success");
          await getProfile(response.data.data.id);
          navigate("/dashboard");
          setSuccess(true);
        } else if (response.data.responseInfo.httpCode === 201) {
          setSuccess(true);
          showSnackbar(response.data.responseInfo?.description, "info");
        } else {
          showSnackbar(response.data.responseInfo?.description, "error");
        }
      } catch (error) {
        console.error("Error during login:", error);
      }
    setIsLoading(false);
  };

  useEffect(() => {
    if (token) verifyLink();
  }, [token]);

  const navigate = useNavigate();

  const handleLogin = () => {
    navigate("/login");
  };

  return (
    <>
      <Backdrop open={isLoading}>
        <CircularProgress size={20} color="inherit" />
      </Backdrop>
      <div className="login_navbar_container">
        <HomeNavbar isHome={true} />

        <div className="main_login_container_ak">
          <div className="login_content_wrapper">
            <div className="login_body_wrapper">
              <div className="login_content_holder">
                <h1 className="white_text">
                  Claim Your Free Pass! Access premium features now.{" "}
                </h1>
                <div className="white_text">
                  Effortlessly post job openings, filter applicants with
                  advanced AI tools, and connect directly with Emirati talent.
                  Simplify your hiring process today!
                </div>
                <img
                  src={images.macbookProMockup}
                  alt="dashboard"
                />
              </div>
            </div>
            <div className="login_form_wrapper_ak">
              <div className="login">
                {!isLoading && (
                  <div className="forgot-form-container verified_form_container">
                    <img
                      src={
                        success
                          ? images.tick03
                          : images.cancel02
                      }
                      alt="otp_email"
                      className="form_img_item"
                    />
                    <h2 className="text-center">
                      {success ? "Success" : "Failed"}
                    </h2>
                    <p className="text-center gray-text">
                      {success
                        ? "Your account has been verified!"
                        : "This link is expired"}
                    </p>
                    <button
                      className="submit-button"
                      onClick={handleLogin}
                      type="submit"
                    >
                      Log In
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verified;
